import * as actions from './Retailers.actions';
import reducer from './Retailers.reducer';
import * as types from './Retailers.types';

export default {
  actions,
  reducer,
  types,
};
